export const inr = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

// All timestamps are shown in Indian Standard Time regardless of device timezone
export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const fmtIST = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true }) + " IST";
  } catch {
    return iso;
  }
};

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

export const roleLabel = (r) =>
  ({
    super_admin: "Super Admin",
    admin: "Admin",
    sales_manager: "Sales Manager",
    sales_executive: "Sales Executive",
    accountant: "Accountant",
  }[r] || r);

export const statusColor = (s) =>
  ({
    new: "bg-blue-100 text-blue-800 border-blue-200",
    contacted: "bg-amber-100 text-amber-800 border-amber-200",
    qualified: "bg-purple-100 text-purple-800 border-purple-200",
    proposal: "bg-orange-100 text-orange-800 border-orange-200",
    won: "bg-emerald-100 text-emerald-800 border-emerald-200",
    lost: "bg-stone-200 text-stone-700 border-stone-300",
    todo: "bg-stone-100 text-stone-800 border-stone-200",
    in_progress: "bg-blue-100 text-blue-800 border-blue-200",
    done: "bg-emerald-100 text-emerald-800 border-emerald-200",
    blocked: "bg-red-100 text-red-800 border-red-200",
    pending: "bg-amber-100 text-amber-800 border-amber-200",
    completed: "bg-emerald-100 text-emerald-800 border-emerald-200",
    missed: "bg-red-100 text-red-800 border-red-200",
    unpaid: "bg-red-100 text-red-800 border-red-200",
    partial: "bg-amber-100 text-amber-800 border-amber-200",
    paid: "bg-emerald-100 text-emerald-800 border-emerald-200",
    overdue: "bg-red-200 text-red-900 border-red-300",
    draft: "bg-stone-100 text-stone-700 border-stone-200",
    sent: "bg-blue-100 text-blue-800 border-blue-200",
    accepted: "bg-emerald-100 text-emerald-800 border-emerald-200",
    rejected: "bg-red-100 text-red-800 border-red-200",
    converted: "bg-purple-100 text-purple-800 border-purple-200",
  }[s] || "bg-stone-100 text-stone-700 border-stone-200");

export const priorityColor = (p) =>
  ({
    low: "bg-stone-100 text-stone-700 border-stone-200",
    medium: "bg-blue-100 text-blue-800 border-blue-200",
    high: "bg-orange-100 text-orange-800 border-orange-200",
    urgent: "bg-red-100 text-red-800 border-red-200",
  }[p] || "bg-stone-100 text-stone-700 border-stone-200");
